// Edit all Sales Advisory page content here.
export const SALES_ADVISORY = {
  seo: {
    path: '/sales-advisory',
    title: 'Sales Advisory for Founders | Founder Growth Collective',
    description: 'Monthly sales advisory for founders still leading sales themselves. Get experienced support with pricing, hiring, pipeline and sales decisions from Hannah Hulley.',
  },
  hero: {
    title: 'Sales Advisory',
    subtitle: 'Experienced sales thinking, without the full engagement.',
    body: 'A monthly advisory service for founders who are still doing the selling themselves and need an experienced person to work through decisions with.',
    ctaText: 'Book a Discovery Call',
    ctaLink: '/book',
  },
  whoFor: {
    heading: "Who it's for",
    lead: 'Founders who are still doing the selling themselves and aren’t ready to design a full sales function yet.',
    body: 'You’re making sales decisions on your own: who to target, what to charge, whether to hire, why a deal went quiet. You don’t need a project. You need someone experienced to check your thinking before you commit.',
  },
  monthly: {
    heading: 'What you get each month',
    items: [
      { title: 'Strategy call', body: '60 minutes. You bring the decision you’re stuck on.' },
      { title: 'Direct access', body: 'Voice notes or messages on weekdays. I reply within one working day.' },
      { title: '"Look at this" reviews', body: 'Up to two a month: pitch deck, outbound sequence, proposal, job spec, comp plan, or your pipeline.' },
      { title: 'Call summary', body: 'A short written note after each call covering what we decided and what to watch.' },
    ],
  },
  notIncluded: {
    heading: "What's not included",
    lead: 'Advisory is thinking alongside you, not building for you.',
    items: [
      'Building your playbook, sales process or hiring campaign. That’s the full Founder Growth Collective engagement.',
      'Same-day turnaround or live deal support. Available as an add-on if you need it.',
    ],
  },
  howItWorks: {
    heading: 'How it works',
    commitment: { label: 'Commitment', body: "3 months minimum, then rolling monthly with one month's notice." },
    investment: { label: 'Investment', price: '£850', period: 'per month' },
    movingUp: { label: 'Moving up', body: "If you move to the full engagement within 90 days, one month's advisory fee comes off the price." },
  },
  finalCta: {
    heading: 'Ready to talk through your sales challenges?',
    body: 'To start, book a 30-minute call.',
    ctaText: 'Book a 30-Minute Call',
    ctaLink: '/book',
  },
};

// Comparison strip (used on /sales-advisory, /services and the homepage).
export const COMPARISON = {
  label: 'Compare',
  heading: 'Sales Advisory or Sales Infrastructure?',
  columns: [
    { key: 'advisory', name: 'Sales Advisory', to: '/sales-advisory' },
    { key: 'infrastructure', name: 'Sales Infrastructure', to: '/services' },
  ],
  rows: [
    { label: 'Best for', values: ['Founders who are still doing the selling themselves', 'Funded startups moving from founder-led sales to scalable revenue'] },
    { label: 'What it is', values: ['Thinking alongside you', 'Building your playbook, sales process or hiring campaign'] },
    { label: 'Format', values: ['Monthly: 60-minute strategy call, direct access, two reviews', 'Full Founder Growth Collective engagement'] },
    { label: 'Investment', values: ['£850 per month, 3 months minimum', 'Scoped to your needs'] },
  ],
};
